import { render, staticRenderFns } from "./DeleteOrderItemCaution.vue?vue&type=template&id=955da454&"
import script from "./DeleteOrderItemCaution.vue?vue&type=script&lang=js&"
export * from "./DeleteOrderItemCaution.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports